import axios from 'axios';

import errorHandler from '../../components/errorHandler/index.js'

const errorHandlerShow = (
    error,
    setToken,
    setAlert,
    setShowAlert
) => {
    const { message, status, expired } = errorHandler(error);
    let message_custom = ""

    if (expired) {
        message_custom = "Code: 403 Message: A sua sessão expirou, faça o login novamente. Você será deslogado em 10s."
        setTimeout(() => { setToken("") }, 10000);
    } else {
        message_custom = 'Code: ' + status + ' Message: ' + message
    }

    setAlert({
        header: 'Something went wrong with your request.', 
        message: message_custom,
        type: 'danger',
        options_btn: []
    })

    // show alert to users
    setShowAlert(true)
};

export default errorHandlerShow